(function () {
  function initReadMore() {
    document.querySelectorAll('[data-readmore]').forEach((block) => {
      const content = block.querySelector('[data-readmore-content]');
      const btn = block.querySelector('[data-readmore-toggle]');
      if (!content || !btn) return;

      // Reset in case of re-init (theme navigation / sections reload)
      block.classList.remove('is-expanded');
      btn.setAttribute('aria-expanded', 'false');
      btn.textContent = btn.getAttribute('data-label-more') || 'Mehr anzeigen';

      // If not overflowing, hide button
      const isOverflowing = () => content.scrollHeight > content.clientHeight + 2;

      // Wait a tick for fonts/layout to settle
      requestAnimationFrame(() => {
        btn.style.display = isOverflowing() ? '' : 'none';
      });

      // Avoid double-binding
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', () => {
        const expanded = block.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        btn.textContent = expanded
          ? (btn.getAttribute('data-label-less') || 'Weniger anzeigen')
          : (btn.getAttribute('data-label-more') || 'Mehr anzeigen');
      });
    });
  }

  // Vivid theme recommended hook
  document.addEventListener('page:loaded', initReadMore);

  // Fallback for first load (just in case)
  document.addEventListener('DOMContentLoaded', initReadMore);

  // Shopify Theme Editor: re-init when sections reload
  document.addEventListener('shopify:section:load', initReadMore);
})();
